/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { LabFeedItem } from "./LabFeedItem";
import type { PrescriptionFeedItem } from "./PrescriptionFeedItem";

export interface PatientOrderHistoryResponse {
  orders?: (LabFeedItem | PrescriptionFeedItem)[];
  has_next_page?: boolean;
  next_cursor?: string | null;
}
